// extracted by mini-css-extract-plugin
export default {"container":"static-data_container__X+PZt","content":"static-data_content__n3b68","title":"static-data_title__KkgQI"};